// src/App.js
import { useEffect, useTransition } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
  useLocation,
} from "react-router-dom";
import { TranslationProvider } from "./hooks/useTranslation";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Rules from "./pages/Rules";
import Winners from "./pages/Winners";
import Prize from "./pages/Prize";
import Footer from "./components/Footer";
import SkipLink from "./components/SkipLink";
import "./styles/main.scss";

// Import GTM utilities
import { initializeGTM, trackPageView } from "./utils/gtm";
import { FloatingButton } from "./components/FloatingButton";

// Component to handle page view tracking
const PageViewTracker = () => {
  const location = useLocation();
  const { lang } = useParams();
  const { basePath } = useTransition();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location, lang, basePath]);

  return null;
};

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Main app content with routes
const AppContent = (lang) => {
  const { basePath } = useTransition();
  return (
    <div className="app">
      <PageViewTracker />
      <ScrollToTop />
      <Navbar currentlang={lang} />
      <main id="main-content" tabIndex="-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:lang" element={<Home />} />
          <Route path="/reeglid" element={<Rules />} />
          <Route path="/:lang/reeglid" element={<Rules />} />
          <Route path="/voitjad" element={<Winners />} />
          <Route path="/:lang/voitjad" element={<Winners />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  const { basePath } = useTransition();
  useEffect(() => {
    initializeGTM();
  }, []);

  return (
    <TranslationProvider>
      <Router
        basename="/vikinglotto"
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <AppContent />
      </Router>
    </TranslationProvider>
  );
}

export default App;
